module.exports = __webpack_public_path__ + "static/img/古柳.5602e94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teacher/古柳.jpg
// module id = j5k8
// module chunks = 139